__turbopack_context__.v({
  "consultant-details": "ConsultantDetails-module-scss-module__JXYqOq__consultant-details",
  "consultant-details__avatar": "ConsultantDetails-module-scss-module__JXYqOq__consultant-details__avatar",
});
